import { Edit, EditProps } from 'react-admin';
import { AdminTitle, formWrapper } from '.';

export default function CustomEdit(props: EditProps) {
  return (
    <>
      <AdminTitle />
      {formWrapper({ ...props, mutationMode: 'pessimistic' })(Edit)}
    </>
  );
}
